import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UserPreferencesContextType {
  allowUnlimitedCriteriaValues: boolean;
  setAllowUnlimitedCriteriaValues: (value: boolean) => void;
}

const defaultValue: UserPreferencesContextType = {
  allowUnlimitedCriteriaValues: false,
  setAllowUnlimitedCriteriaValues: () => {},
};

const UserPreferencesContext = createContext<UserPreferencesContextType>(defaultValue);

export const useUserPreferences = () => useContext(UserPreferencesContext);

interface UserPreferencesProviderProps {
  children: ReactNode;
}

export const UserPreferencesProvider = ({ children }: UserPreferencesProviderProps) => {
  const [allowUnlimitedCriteriaValues, setAllowUnlimitedCriteriaValues] = useState<boolean>(false);

  const value = {
    allowUnlimitedCriteriaValues,
    setAllowUnlimitedCriteriaValues,
  };

  return (
    <UserPreferencesContext.Provider value={value}>
      {children}
    </UserPreferencesContext.Provider>
  );
}; 